import { defineMessages } from '@openedx/frontend-base';

const messages = defineMessages({
  courses: {
    id: 'category.header.course',
    defaultMessage: 'Courses',
    description: 'The text for the link to the Courses page.',
  },
  exploreCourses: {
    id: 'category.header.explore',
    defaultMessage: 'Explore',
    description: 'The text for the link to the Explore page.',
  },
  programs: {
    id: 'category.header.programs',
    defaultMessage: 'Programs',
    description: 'The text for the link to the Programs page.',
  },
  discoverNew: {
    id: 'category.header.discoverNew',
    defaultMessage: 'Discover new',
    description: 'The text for the link to the Discover new page.',
  },
});

export default messages;
